import Profile from '../../components/Profile'
import DriverLayout from '../../layouts/DriverLayout'

const DriverProfile = () => {
    return (
        <DriverLayout>
            <Profile />
        </DriverLayout>
    )
}

export default DriverProfile
